import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AgentApi {
  constructor(private http: HttpClient) {}

  private prospektrBackendBaseURL = environment.prospektrBackendBaseURL;

  getAgentList(params) {
    return this.http.get(`${this.prospektrBackendBaseURL}agents`, {
      params: params,
    });
  }
}
